import {
    Content as PropsContent,
    Selector as PropsSelector,
    Event as PropsEvent,
} from '@/models/Props';

import './Button.scss';

const Button = ({
    content,
    className,
    onClick,
}: PropsContent & PropsSelector & PropsEvent) => {
    return (
        <button
            onClick={onClick}
            className={'btn' + (className ? ` ${className}` : '')}
        >
            <div>{content}</div>
        </button>
    );
};

export default Button;
